import React from 'react';
import pathWithRewrite from 'utils/pathWithRewrite';
import { StyledMobileNav, StyledLink } from './styled';

const MobileNav = ({ items, isOpen }) => {
  return (
    <StyledMobileNav>
      <ul>
        {
          items && items.map((item, i) => {
            const rewrite = pathWithRewrite(item);
            if (rewrite.location === null) { return false; }
            const external = rewrite.location.startsWith('http');
            const LinkComponent = external ?
              StyledLink.withComponent('a') :
              StyledLink;
            const linkProps = external ? {
              tabIndex: isOpen ? '0' : '-1',
              href: rewrite.location,
              target: rewrite.target,
            } : {
              activeClassName: 'active',
              tabIndex: isOpen ? '0' : '-1',
              to: item.path,
              exact: true,
            }
            return (
              <li key={i}>
                <LinkComponent {...linkProps} onClick={() => {
                  window.gtag && gtag('event', 'mobile_menu_click', {
                    event_category: 'navigation',
                    event_label: linkProps.to || linkProps.href
                  });
                }}>
                  {item.title}
                </LinkComponent>
              </li>
            );
          })
        }
      </ul>
    </StyledMobileNav>
  );
};

export default MobileNav;



// WEBPACK FOOTER //
// ./src/modules/Header/components/MobileMenu/components/MobileNav/MobileNav.jsx